import { Observable, Observer, Subject } from 'rxjs';

export class Counter {
  id: number;
  name: string;
  countMax: number;
  countMin: number;
  tag: any;
  countChanged = new Subject();
  private _familyParentName?: string;
  private _familyChildrenName?: string;
  private _familyParentsLimit?: number;
  private _familyChildrenLimit?: number;

  private _count: number;

  disableUp: boolean;

  constructor(
    id = 0,
    count = 0,
    name,
    tag,
    countMax = 1000,
    countMin = 0,
    familyParentName = '',
    familyChildrenName = '',
    familyParentsLimit = 0,
    familyChildrenLimit = 0,
  ) {
    this.id = id;
    this.count = count;
    this.name = name;
    this.tag = tag;
    this.countMax = countMax;
    this.countMin = countMin;
    this._familyParentName = familyParentName;
    this._familyChildrenName = familyChildrenName;
    this._familyParentsLimit = familyParentsLimit;
    this._familyChildrenLimit = familyChildrenLimit;
  }

  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    if (value === this._count) {
      return;
    }

    if (this.countMin && value < this.countMin && value > this._count) {
      value = this.countMin;
    }

    if (this.countMin && value < this.countMin && value < this._count) {
      value = 0;
    }

    this._count = value;
    this.countChanged.next(value);
  }

  get canCountUp() {
    // if (this.isFamilyParentsCounter && this.familyParentsLimit) {
    //   return this._count < this.familyParentsLimit;
    // }

    // if (this.isFamilyChildrenCounter && this.familyChildrenLimit) {
    //   return this._count < this.familyChildrenLimit;
    // }

    return !this.disableUp && this._count < this.countMax && this.countMax >= this.countMin;
  }

  get canCountDown() {
    if (this._count && this.countMin > 0 && this._count === this.countMin) {
      return true;
    }
    return this._count > this.countMin;
  }

  get familyParentName(): string {
    return this._familyParentName;
  }

  get familyChildrenName(): string {
    return this._familyChildrenName;
  }

  get familyParentsLimit(): number {
    return this._familyParentsLimit;
  }

  get familyChildrenLimit(): number {
    return this._familyChildrenLimit;
  }

  get isFamilyParentsCounter(): boolean {
    return this.name && this.familyParentName.indexOf(this.name) > -1;
  }

  get isFamilyChildrenCounter(): boolean {
    return this.name && this.familyChildrenName.indexOf(this.name) > -1;
  }

  toString(): string {
    return `id: ${this.id} count: ${this._count} name: ${this.name} familyChildrenLimit: ${this._familyChildrenLimit}`;
  }
}
